import styled from '@emotion/styled';
import lift from 'storybookConfig/mixins/lift';
import Button from 'storybookConfig/stories/molecules/Button';

interface DecisionButtonProps {
  isActive: boolean;
  $padding?: string;
}

const DecisionButton = styled(Button, {
  shouldForwardProp: (prop) => !['isActive', '$padding'].includes(prop),
})<DecisionButtonProps>`
  all: unset;
  padding: ${({ $padding = '24px' }) => $padding};
  /* Selected is the iris family, like every other selection: the lightest fill, an iris edge. */
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.color.accentSubtle : theme.color.surfaceCanvas};
  border: 1px solid
    ${({ theme, isActive }) => (isActive ? theme.color.accentBorder : theme.color.border)};
  border-radius: ${({ theme }) => theme.radius.xl};
  cursor: pointer;

  /* The shared lift, in the lighter iris edge; the fill is for the selected card. */
  ${({ isActive }) => lift({ edge: 'accentBorder', selected: isActive })};
  transition:
    background-color ${({ theme }) => theme.motion.hover} ${({ theme }) => theme.motion.easeOut},
    border-color ${({ theme }) => theme.motion.hover} ${({ theme }) => theme.motion.easeOut},
    box-shadow ${({ theme }) => theme.motion.hover} ${({ theme }) => theme.motion.easeOut};
`;

export default DecisionButton;
